<template>
	<div class="page flex-column">
		<div class="head flex-center">
			<p>{{title}}</p>
			<div class="exit flex-center" @click="exitHandle"><i class="tf">&#xe620;</i>退出大屏</div>
		</div>
		<div class="body flex-column flex-grow">
			<div v-for="(row, i) in layout" :key="i" class="body-row flex flex-grow">
				<template v-for="(item, j) in row">
					<module-quota v-if="item.module_type == 2" :key="j" :id="item.module_id" :notice="i == 0"></module-quota>
					<module-charts v-else-if="item.module_type == 1" :key="j" :id="item.module_id" :horizontal="i == 1 || row.length == 1"></module-charts>
					<module-list v-else-if="item.module_type == 3" :key="j" :id="item.module_id"></module-list>
				</template>
			</div>
		</div>

		<c-dialog ref="digitalList" width="600" :title="false" :close-button="false" :button="false">
			<dl class="digital-list">
				<dt>请选择数据看板</dt>
				<dd>
					<ul>
						<li class="flex-center" tabindex="0" @click="navigateTo('/bakeTaskKanban')" @keydown.enter="navigateTo('/bakeTaskKanban')">
							<i class="icon tf-nav-p_workshop"></i>
							<p class="flex-grow ellipsis">烘烤任务看板</p>
						</li>
						<li class="flex-center" tabindex="0" @click="navigateTo('/bakeKanban')" @keydown.enter="navigateTo('/bakeKanban')">
							<i class="icon tf-nav-p_workshop"></i>
							<p class="flex-grow ellipsis">机台看板</p>
						</li>
						<li class="flex-center" tabindex="0" @click="navigateTo('/digitalold')" @keydown.enter="navigateTo('/digitalold')">
							<i class="icon tf-nav-p_workshop"></i>
							<p class="flex-grow ellipsis">（内置）车间看板</p>
						</li>
						<li v-for="(item, i) in digitalList" :key="i" class="flex-center" tabindex="0" @click="navigateTo(`/digital/${item.digital_id}`)" @keydown.enter="navigateTo(`/digital/${item.digital_id}`)">
							<i class="icon tf-nav-p_workshop"></i>
							<p class="flex-grow ellipsis">{{item.menu_name}}</p>
						</li>
					</ul>
				</dd>
			</dl>
		</c-dialog>
	</div>
</template>

<script>
	import moduleQuota from './components/digital_quota.vue'
	import moduleCharts from './components/digital_charts.vue'
	import moduleList from './components/digital_list.vue'
	import {SYS} from '@/config'
	import {createStore, mapStore, throttle} from '@deanwu/vue-component-library'

	export default {
		components: {
			moduleQuota,
			moduleCharts,
			moduleList
		},

		props: {
			id: String
		},

		data() {
			return {
				digitalStore: createStore({
					px(n) {
						if (window.innerWidth >= 1400) {
							return n;
						} else {
							return n * Math.min(1, 0.000714796 * window.innerWidth);
						}
					},
					registerChart: obj => {
						this.charts.push(obj);
					},
					processRateScale: 1
				}),
				digitalList: [],
				digitalId: '',
				title: '',
				layout: [],
				charts: []
			}
		},

		computed: {
			...mapStore('digitalStore', ['px'])
		},

		watch: {
			id: {
				handler(val) {
					this.title = '';
					this.layout = [];
					this.charts = [];
					if (val) {
						this.$refs.digitalList && this.$refs.digitalList.close();
						this.update();
					} else {
						this.request({
							url: '/digital/menu',
							success: data => {
								// if (!data.length) {
								// 	this.navigateTo('/digitalold');
								// 	return;
								// }
								this.digitalList = data;
								this.$refs.digitalList.open();
								setTimeout(() => {
									document.querySelector('.digital-list li')?.focus();
								}, 100);
							}
						});
					}
				},
				immediate: true
			}
		},
		
		mounted() {
			this.fullHandle();
			this.digitalStore.commit('processRateScale', this.px(70) / 70);
			window.addEventListener('resize', throttle(() => {
				this.charts.forEach(item => {
					item.resize();
				});
				this.digitalStore.commit('processRateScale', this.px(70) / 70);
			}, 500));
		},
		
		methods: {
			update() {
				this.request({
					url: '/digital/info',
					data: {
						digital_id: this.id
					},
					success: data => {
						this.digitalId = data.id;
						this.title = data.title;
						this.layout = data.config_json;
					}
				})
			},

			fullHandle() {
				if (SYS == 'digital') return;
				const elem = document.documentElement;
				if (elem.requestFullscreen) {
					elem.requestFullscreen();
				} else if (elem.mozRequestFullScreen) {
					elem.mozRequestFullScreen();
				} else if (elem.webkitRequestFullscreen) {
					elem.webkitRequestFullscreen();
				} else if (elem.msRequestFullscreen) {
					elem.msRequestFullscreen();
				}
			},

			exitHandle() {
				if (SYS == 'digital') {
					this.logout();
					return;
				}
				if (document.exitFullscreen) {
					document.exitFullscreen();
				} else if (document.mozCancelFullScreen) {
					document.mozCancelFullScreen();
				} else if (document.webkitExitFullscreen) {
					document.webkitExitFullscreen();
				} else if (document.msExitFullscreen) {
					document.msExitFullscreen();
				}
				this.navigateTo('/');
			},
			
			logout() {
				this.request({
					url: '/sys_user/logout',
					loading: true,
					success: () => {
						this.$store.commit('setSession', '');
						this.navigateTo('/login');
					}
				});
			}
		}
	}
</script>

<style lang="stylus">
	html {
		font-size: 100px;

		@media screen and (max-width: 1399px) {
			font-size: 7.14796vw;
		}
	}
</style>

<style lang="stylus" scoped>
	.page {
		box-sizing: border-box;
		height: 100vh;
		overflow: hidden;
		background-color: #011131;
		background-image: url('~@/assets/image/digital/bg.jpg');
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		user-select: none;

		.head {
			position: relative;
			height: .72rem;
			margin-bottom: .15rem;
			background-image: url('~@/assets/image/digital/head.png');
			background-size: auto 100%;
			background-position: center;
			
			&:after {
				content: '';
				position: absolute;
				left: 0;
				top: 0;
				width: .5rem;
				height: .02rem;
				background-image: url('~@/assets/image/digital/an_head.png');
				background-size: 100%;
				animation: headMove 5s infinite linear;
			
				@keyframes headMove {
					0% {
						opacity: 0;
						transform: translate(0,0);
					}
					10% {
						opacity: 1;
					}
					70% {
						opacity: 1;
					}
					80% {
						opacity: 0;
						transform: translate(100vw,0);
					}
					100% {
						opacity: 0;
						transform: translate(100vw,0);
					}
				}
			}

			p {
				padding-bottom: .05rem;
				font-size: .32rem;
				font-weight: bold;
				color: transparent;
				background: linear-gradient(to bottom, #FFFFFF, #75DAFF);
				background-clip: text;
			}

			.exit {
				position: absolute;
				top: -.03rem;
				right: .9rem;
				width: 1.2rem;
				height: .44rem;
				font-size: .14rem;
				color: #00F6C2;
				background-image: url('~@/assets/image/digital/exit.png');
				background-size: 100% 100%;
				cursor: pointer;

				.tf {
					margin-right: .08rem;
				}
			}
		}

		.body {
			padding: 0 .15rem .15rem;

			&-row {
				&:nth-child(1) {
					flex-grow: 1.375;
				}

				&:nth-child(n+2) {
					margin-top: .15rem;
				}

				.m-quota:nth-child(n+2),
				.m-charts:nth-child(n+2),
				.m-list:nth-child(n+2) {
					margin-left: .15rem;
				}
			}
		}
	}

	>>> .c-empty {
		&-icon {
			width: .8rem;
			height: .8rem;
		}

		&-message {
			margin-top: .1rem;
			font-size: .16rem;
		}
	}

	.digital-list {
		border-radius: 10px;
		padding: 0 30px 40px;
		background: #FFFFFF;

		dt {
			line-height: 100px;
			font-size: 24px;
			font-weight: bold;
			text-align: center;
		}

		dd {
			li {
				height: 60px;
				border-radius: 4px;
				padding: 0 22px;
				margin-bottom: 13px;
				color: #fff;
				background: #32373E;
				cursor: pointer;

				&:hover {
					background: #0D71A1;
				}

				.icon {
					margin-right: 16px;
					font-size: 20px;
				}
			}
		}
	}
	// 电视遥控器 焦点高亮样式
	.digital-list dd li {
		outline none // 去掉默认焦点框
		&:focus {
			background #0D71A1 !important;
			outline 3px solid #00ffcc !important;
		}
	}
</style>
